module.exports = __webpack_public_path__ + "static/media/PokerHandPostBadge_logoweb.aa2b2c9a.png";